import { MessageCircle } from 'lucide-react';
import './WhatsAppButton.css';

function WhatsAppButton() {
  const phoneNumber = '4368120179697'; // +43 681 20179697 ohne + und Leerzeichen
  const message = 'Hallo Andreas! Ich interessiere mich für eine Videoproduktion.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
      data-testid="whatsapp-button"
      aria-label="WhatsApp Chat"
    >
      <MessageCircle size={28} />
      <span className="whatsapp-text">WhatsApp</span>
    </a>
  );
}

export default WhatsAppButton;
